import React, { useMemo, useEffect } from "react";
import { useClient } from "ClientContext";

interface LodgifyCheckoutLinkType {
  readonly clientName: string;
  readonly checkIn: string;  // must be yyyy-MM-dd format
  readonly checkOut: string; // must be yyyy-MM-dd format
  readonly guestsNum: string;
  readonly currency: string;
  readonly listingId: string;
}

const LodgifyCheckoutIframe: React.FC<LodgifyCheckoutLinkType> = ({
  clientName,
  checkIn,
  checkOut,
  guestsNum,
  currency,
  listingId,
}) => {
  // Scroll to the top when this component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { global_language, internal_ID } = useClient();

  const iframeSrc = useMemo(
    () =>
      `https://checkout.lodgify.com/${global_language || "en"}/${clientName}/${listingId}/addons?currency=${currency}&ref=bnbox&arrival=${checkIn}&departure=${checkOut}&guests=${guestsNum}`,
    [clientName, listingId, currency, checkIn, checkOut, guestsNum]
  );


  return (
    <div className="w-screen h-screen flex flex-col items-center">
      <iframe
        src={iframeSrc}
        title="Lodgify Checkout"
        className="w-full h-[1200px] mb-5" // Set to half the screen height
        style={{ border: 'none' }}
      />
    </div>
  );
};

export default LodgifyCheckoutIframe;